// Tabla §3.3 — condiciones frente al IVA del receptor válidas en Factura C.
// Extraída acá en la pasada 6 del loop: antes duplicada idéntica en
// Facturar.js (una por factura) y Arca.js (default por profesional) — un
// código nuevo habilitado por ARCA/AFIP que se agregara en un archivo y no
// en el otro dejaba a un profesional con un default configurado que
// Facturar.js todavía no ofrecía como opción seleccionable a mano.
export const CONDICIONES_IVA = [
  { id: 5, label: 'Consumidor Final' },
  { id: 4, label: 'IVA Sujeto Exento' },
  { id: 1, label: 'IVA Responsable Inscripto' },
  { id: 6, label: 'Responsable Monotributo' },
  { id: 15, label: 'IVA No Alcanzado' },
]
